import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import PageContent from '../Content'

export default class Modules extends PageContent {

    // TODO: load baseName from config.json
    async loadItems() {
        const getItems = async () => {
            const response = await fetch(
                process.env.PUBLIC_URL + '/data/modules.json'
            );
            const data = await response.json();
            this.setItems(data);
        };
      
        await getItems();
    }

    runCustomFilter() {
        let filter;

        const compare = this.wholeWords?
            (str, substr) => str.toLocaleLowerCase() === substr:
            (str, substr) => str.toLocaleLowerCase().includes(substr);

        if(this.module && this.field) {
            filter = item => 
                (compare(item.oldModuleName, this.module) || compare(item.newModuleName, this.module)) && 
                (compare(item.oldColumnName, this.field) || compare(item.newColumnName, this.field)
            );
        } else if(this.module) {
            filter = item => compare(item.oldModuleName, this.module) || compare(item.newModuleName, this.module);
        } else if(this.field) {
            filter = item => compare(item.oldColumnName, this.field) || compare(item.newColumnName, this.field)
        } else {
            filter = item => true;
        }
        this.setFilter(filter);
    }

    getNav() {
        return (
            <Container className='mt-4'>
                <Row>
                    <Col>
                        <Form.Control 
                            placeholder='Modul'
                            onChange={e => this.module = e.target.value.toLocaleLowerCase()} 
                            onKeyDown={(e) => { if(e.key === 'Enter') this.runCustomFilter(); }} 
                        />
                    </Col>
                    <Col>
                        <Form.Control 
                            placeholder='Pole'
                            onChange={e => this.field = e.target.value.toLocaleLowerCase()} 
                            onKeyDown={(e) => { if(e.key === 'Enter') this.runCustomFilter(); }} 
                        />
                    </Col>
                </Row>
                <Row className='mt-4'>
                    <Col className='text-end'>
                    <Button variant='success' onClick={() => this.runCustomFilter()}>Hledat</Button>
                    </Col>
                    <Col className='align-middle' style={{display: 'flex', alignItems: 'center'}}>
                        <Form.Check label='Celá slova' onClick={e => this.wholeWords = e.target.value}/>
                    </Col>
                </Row>
            </Container>
        );
    }

    getTableHeader() {
        return (
            <tr>
                <th className='col-md-1'>Starý modul</th>
                <th className='col-md-1'>Nový modul</th>
                <th className='col-md-1'>Staré pole</th>
                <th className='col-md-1'>Nové pole</th>
            </tr>
        );
    }

    getRow(item, index) {

        let cols = [];
        cols.push(<td key={'oldModuleName'+index}>{item.oldModuleName}</td>);
        cols.push(<td key={'newModuleName'+index}>{item.newModuleName}</td>);
        if(item.oldColumnName) {
            if(item.columnNameState === 'deleted') {
                cols.push(
                    <td key={'oldColumnName'+index}>
                        <span className='text-danger'>{item.oldColumnName}</span>
                        <span className='text-muted'>{` : ${item.oldColumnType}`}</span>
                    </td>
                );
            } else {
                cols.push(
                    <td key={'oldColumnName'+index}>
                        <span>{item.oldColumnName}</span>
                        <span className='text-muted'>{` : ${item.oldColumnType}`}</span>
                    </td>
                );
            }
        } else {
            cols.push(<td key={'oldColumnName'+index} />)
        }

        if(item.newColumnName) {
            if(item.columnNameState === 'added') {
                cols.push(
                    <td key={'newColumnName'+index}>
                        <span className='text-success'>{item.newColumnName}</span>
                        <span className='text-muted'>{` : ${item.newColumnType}`}</span>
                    </td>
                );
            } else {
                cols.push(
                    <td key={'newColumnName'+index}>
                        <span>{item.newColumnName}</span>
                        <span className='text-muted'>{` : ${item.newColumnType}`}</span>
                    </td>
                );
            }
        } else {
            cols.push(<td key={'newColumnName'+index} />)
        }

        return (
            <tr key={index}>{cols}</tr>
        );
    }
}